enum WorkspaceProjectUtilityUnitOfMeasurementType {
  'Text' = 'Text',
  'Currency' = 'Currency',
  'Number' = 'Number',
  'Percent' = 'Percent',
}

export default WorkspaceProjectUtilityUnitOfMeasurementType
